import { RequireAuth, UserRole } from 'legoland-sdk/dist/experimental';
import { useState } from 'react';
import { Box, Button, Text, Tooltip, tombac } from 'tombac';
import { EditIcon, RocketIcon, ScheduleIcon } from 'tombac-icons';
import { useApigeeDeveloperQuery } from "../api/userManagementApiHooks";
import { EditUserApigeeDeveloperModal } from "./EditUserApigeeDeveloperModal";
import { RotateUserApigeeKeyModal } from "./RotateUserApigeeKeyModal";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UserApigeeDeveloper = _ref => {
  let {
    user
  } = _ref;
  const {
    data
  } = useApigeeDeveloperQuery({
    username: user.email
  });
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isConfirmRotationOpen, setIsConfirmRotationOpen] = useState(false);
  if (!data?.developer) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Text, {
    $color: tombac.color('neutral', 600),
    as: "span",
    className: "EditUserPage__apigee-mail",
    $mt: "0.5sp",
    "data-sentry-element": "Text",
    "data-sentry-component": "UserApigeeDeveloper",
    "data-sentry-source-file": "UserApigeeDeveloper.tsx",
    children: [/*#__PURE__*/_jsx(RocketIcon, {
      fixedWidth: false,
      size: "xs",
      "data-sentry-element": "RocketIcon",
      "data-sentry-source-file": "UserApigeeDeveloper.tsx",
      "data-sentry-element": "RocketIcon"
    }), /*#__PURE__*/_jsx(Box, {
      className: "EditUserPage__apigee-mail-text",
      as: "span",
      $ml: "1sp",
      $pt: "0.2em",
      "data-sentry-element": "Box",
      "data-sentry-source-file": "UserApigeeDeveloper.tsx",
      "data-sentry-element": "Box",
      children: data.developer.mail
    }), /*#__PURE__*/_jsxs(RequireAuth, {
      role: UserRole.Admin,
      "data-sentry-element": "RequireAuth",
      "data-sentry-source-file": "UserApigeeDeveloper.tsx",
      "data-sentry-element": "RequireAuth",
      children: [/*#__PURE__*/_jsx(EditUserApigeeDeveloperModal, {
        isOpen: isEditOpen,
        mail: data.developer.mail,
        onRequestClose: () => setIsEditOpen(false),
        "data-sentry-element": "EditUserApigeeDeveloperModal",
        "data-sentry-source-file": "UserApigeeDeveloper.tsx",
        "data-sentry-element": "EditUserApigeeDeveloperModal"
      }), /*#__PURE__*/_jsx(Button, {
        className: "EditUserPage__apigee-edit-button",
        $ml: "1sp",
        onClick: () => setIsEditOpen(true),
        shape: "circle",
        size: "xs",
        variant: "flat",
        "data-sentry-element": "Button",
        "data-sentry-source-file": "UserApigeeDeveloper.tsx",
        "data-sentry-element": "Button",
        children: /*#__PURE__*/_jsx(EditIcon, {
          size: "xs",
          "data-sentry-element": "EditIcon",
          "data-sentry-source-file": "UserApigeeDeveloper.tsx",
          "data-sentry-element": "EditIcon"
        })
      }), /*#__PURE__*/_jsx(RotateUserApigeeKeyModal, {
        isOpen: isConfirmRotationOpen,
        onRequestClose: () => setIsConfirmRotationOpen(false),
        "data-sentry-element": "RotateUserApigeeKeyModal",
        "data-sentry-source-file": "UserApigeeDeveloper.tsx",
        "data-sentry-element": "RotateUserApigeeKeyModal"
      }), /*#__PURE__*/_jsx(Tooltip, {
        size: "m",
        variant: "inverted",
        closeOnOutsideClick: false,
        content: "Rotate API key",
        "data-sentry-element": "Tooltip",
        "data-sentry-source-file": "UserApigeeDeveloper.tsx",
        "data-sentry-element": "Tooltip",
        children: _ref2 => {
          let {
            ref,
            open,
            close
          } = _ref2;
          return /*#__PURE__*/_jsx(Button, {
            ref: ref,
            onMouseEnter: open,
            onMouseLeave: close,
            className: "EditUserPage__apigee-edit-button",
            onClick: () => setIsConfirmRotationOpen(true),
            shape: "circle",
            size: "xs",
            variant: "flat",
            children: /*#__PURE__*/_jsx(ScheduleIcon, {
              size: "xs"
            })
          });
        }
      })]
    })]
  });
};